import defaultSlide from './defaultSlide';

const defaultFieldValues = {
  thumbnailPath: {
    url: ''
  },
  name: 'untitled',
  enabled: true,
  order: 0,
  overview: {
    position: {
      left: '10%',
      right: '10%',
      top: '10%',
      bottom: '10%',
      alignSelf: 'center',
      justifySelf: 'center'
    },
    color: '#f4d29e',
    enabled: true,
  },
  quote: {
    position: {
      left: '10%',
      right: '10%',
      top: '10%',
      bottom: '10%',
      alignSelf: 'center',
      justifySelf: 'center'
    },
    color: '#f4d29e'
  },
  slides: [defaultSlide],
  credits: {
    background: {
      backgroundColor: '#f4d29e',
      backgroundImage: {
        url: ''
      }
    },
    position: {
      left: '10%',
      right: '10%',
      top: '10%',
      bottom: '10%',
      alignSelf: 'center',
      justifySelf: 'center'
    },
    enabled: true,
    fields: [
      {
        label: 'Lead artist',
        value: 'Andy Dufford'
      }
    ]
  }
};

export default defaultFieldValues;



// WEBPACK FOOTER //
// ./src/containers/add/defaultFieldValues.js